import { useCreateSmartListDialog } from 'features/smart-lists';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plus16 } from 'shared/assets/icons';
import { SideNavigationItem } from 'shared/components/ui/side-navigation-item';
import { SmartListFormDialog } from 'shared/dialogs/smart-list-form-dialog';

export const CreateSmartListSideNavigationItem: React.FC = () => {
  const { t } = useTranslation();
  const { open, isOpen, close } = useCreateSmartListDialog();

  return (
    <>
      <SideNavigationItem
        label={t('general.labels.new-smart-list')}
        icon={Plus16}
        onClick={open}
        prominent
      />

      {isOpen && <SmartListFormDialog open onClose={close} />}
    </>
  );
};
